import 'dayjs/locale/hr'
import { Dayjs } from 'dayjs'

const hr = {
  calendar: {
    sameDay: '[danas u] LT',
    nextDay: '[sutra u] LT',
    nextWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
          return now.format('[u] [nedjelju] [u] LT')
        case 3:
          return now.format('[u] [srijedu] [u] LT')
        case 6:
          return now.format('[u] [subotu] [u] LT')
        case 1:
        case 2:
        case 4:
        case 5:
          return now.format('[u] dddd [u] LT')
      }
    },
    lastDay: '[jučer u] LT',
    lastWeek: function (now: Dayjs) {
      switch (now.day()) {
        case 0:
          return now.format('[prošlu] [nedjelju] [u] LT')
        case 3:
          return now.format('[prošlu] [srijedu] [u] LT')
        case 6:
          return now.format('[prošle] [subote] [u] LT')
        case 1:
        case 2:
        case 4:
        case 5:
          return now.format('[prošli] dddd [u] LT')
      }
    },
    sameElse: 'L'
  }
}

export default hr
